import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen md:min-h-screen flex items-center justify-center overflow-hidden" style={{minHeight: 'clamp(50vh, 55vh, 100vh)'}}>
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/841bd82c166d319c7dd5e6961f4b74c4.jpg"
          alt="Kho phế liệu chuyên nghiệp"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/5d8da8eee9be162d10ff6f63254f0c4f.png" 
              alt="Nam Phát Logo" 
              className="h-12 w-auto object-contain"
            />
            <div>
              <h2 className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>Thu Mua Phế Liệu Giá Cao</h2>
              <p className={`text-sm ${isScrolled ? 'text-gray-600' : 'text-gray-200'}`}>Uy tín - Chất lượng</p>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Giới Thiệu</a>
            <a href="#services" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Dịch Vụ</a>
            <a href="#process" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Quy Trình</a>
            <a href="#contact" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Liên Hệ</a>
          </div>
          <a href="tel:0968947136" className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap flex items-center gap-2">
            <i className="ri-phone-fill"></i>
            Gọi Ngay
          </a>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-black/70 backdrop-blur-sm px-5 py-2 rounded-full mb-4 md:mb-8">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-star-fill text-amber-400 text-base"></i>
          </div>
          <span className="text-white text-sm font-medium">Uy Tín 15+ Năm Kinh Nghiệm</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold text-white leading-tight mb-3 md:mb-6">
          THU MUA PHẾ LIỆU<br />
          <span className="text-amber-400">GIÁ CAO</span> - TẬN NƠI<br />
          <span className="text-amber-400">THANH TOÁN NGAY</span>
        </h1>

        <p className="text-sm sm:text-base md:text-xl text-gray-200 mb-5 md:mb-12 max-w-3xl mx-auto leading-relaxed">
          Chuyên thu mua sắt thép, nhôm, đồng, inox, máy móc cũ, nhà xưởng thanh lý<br className="hidden sm:block" />
          Phục vụ 24/7 - Miễn phí khảo sát - Cam kết giá tốt nhất thị trường
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a href="tel:0968947136" className="bg-amber-400 hover:bg-amber-500 text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-bold transition-all whitespace-nowrap flex items-center gap-3 shadow-xl hover:shadow-2xl hover:scale-105">
            <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-lg md:text-xl"></i>
            </div>
            GỌI NGAY: 0968.947.136
          </a>
          <a href="#contact" className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-bold transition-all whitespace-nowrap flex items-center gap-3">
            BÁO GIÁ MIỄN PHÍ
            <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg md:text-xl"></i>
            </div>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}